module.exports = __webpack_public_path__ + "img/modern.08a2361a.png";